import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => ({
  lRoot: {
    height: ({ vhUpdated }) => vhUpdated * 100,
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "center",
    padding: theme.spacing(2),
    background: theme.palette.background.defaultGradient,
  },

  lFormWrapper: {
    width: "100%",
    padding: theme.spacing(0, 2),
    borderRadius: theme.spacing(0.5),
    background: "transparent",
  },

  logoClass: {
    width: "100%",
    padding: theme.spacing(6, 4),
  },

  submitWrapper: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    padding: theme.spacing(2, 0),
  },

  link: {
    color: theme.palette.primary.main,
    textDecoration: "underline",
    fontSize: theme.typography.body1.fontSize,
    cursor: "pointer",
    margin: theme.spacing(4, 0),
  },

  formHelper: {
    padding: theme.spacing(0, 2),
    marginTop: theme.spacing(1),
  },
}));
